import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => import('./features/views/public/home/home.module').then(m => m.HomeModule) },
  { path: 'unsubscribe-messages', loadChildren: () => import('./features/views/public/unsubscribe/unsubscribe.module').then(m => m.UnsubscribeModule) },
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled' // Esto habilita la restauración de la posición de desplazamiento
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
